import React, { FC } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import ScreenAccordian from "../Screen/ScreenAccordian";
import CentorScreenAccordian from "../CentorScreen/CentorScreenAccordian";
import { Typography } from "@mui/material";
import { Image } from "cloudinary-react";
import { styled } from "@mui/material/styles";
import PleaseNote from "../PleaseNote";
import LearnMore from "../LearnMore";
import useScreenTypeSelector from "./useScreenTypeSelector";
import { addScrollElements } from "../AccordionWrapper/AccordianWrapper";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

const StyledDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  paddingTop: 10,
});


const BrioOrCentorAccordian: FC = () => {
  const {
    brioOnlyOption,
    centorOnlyOption,
    hideScreens,
    isBrio,
    isCentor,
    handleClick,
    centorSectionImgs,
    widerThan16,
    widerThanLimitForPicoSwingSingleScreen,
    isPocketAllowed,
    screenTypeChoice,
    screenTypeChoices,
    noSinglePocktRange,
    width,
    widthRight,
    bifoldAlumNoScreen,
  } = useScreenTypeSelector();
  const { readOnly } = useIsReadOnlyContextProviderContext();

  if (hideScreens) return null;

  if (bifoldAlumNoScreen) {
    return (
      <ReusableAccordian
        accordionName="screen"
        heading="Centor Screen"
        secondaryHeading="Select Screen Option"
      >
        <Typography>
          Centor Screen only available with Raised Sill.
        </Typography>
      </ReusableAccordian>
    );
  }

  return (
    <>
      {screenTypeChoices?.length > 1 && (
        <ReusableAccordian
          accordionName={"screenType"}
          heading="Screen Type"
          secondaryHeading="Select a Screen Type"
          colOrRow="col"
        >
          <>
            {isCentor && (
              <Typography>
                Featuring a flat material that rolls up and provides the option
                for either screen mesh or shade.
              </Typography>
            )}

            {isBrio && (
              <Typography>
                Featuring an accordion-style material that folds up
              </Typography>
            )}
            {screenTypeChoice && (
              <LearnMore href="https://agmillworks.com/retractable-screens/" />
            )}

            <StyledDiv>
              {screenTypeChoices.map((item) => (
                <div key={item.id} onClick={() => readOnly ? null : handleClick(item.label)}>
                  <Choices
                    label={item.label}
                    variant={
                      item.label === screenTypeChoice ? "filled" : "outlined"
                    }
                    checkMark={item.label === screenTypeChoice}
                    disabled={readOnly}
                  />
                </div>
              ))}
            </StyledDiv>

            {isCentor && centorSectionImgs && (
              <StyledDiv style={{ paddingTop: 40 }}>
                <Image
                  cloudName="ag-millworks"
                  secure="true"
                  publicId={centorSectionImgs.jambLeg}
                  style={{ paddingRight: 30 }}
                />
                <Image
                  cloudName="ag-millworks"
                  secure="true"
                  publicId={centorSectionImgs.headSill}
                  style={{ paddingLeft: 30 }}
                />
              </StyledDiv>
            )}

            {isCentor && (
              <PleaseNote
                notes="To simplify installation, we have integrated the Centor Screen framing into our frame and added wood blocking to fill any gaps. This design requires only one rough opening through the jamb. The Net Frame Width (NFW) and Net Frame Height (NFH) measurements include the screen frame."
              />
            )}
          </>
        </ReusableAccordian>
      )}

      {brioOnlyOption ||
      (!brioOnlyOption &&
        screenTypeChoice &&
        !isCentor &&
        !centorOnlyOption) ? (
        <>
          {addScrollElements([
            "Add Screen",
            "Screen Layout",
            "Screen Extrusion Color",
            "Brio Retractable Screen"
          ])}

          <ScreenAccordian
            noSinglePocktRange={noSinglePocktRange}
            isPocketAllowed={isPocketAllowed}
            widerThan16={widerThan16}
            widerThanLimitForPicoSwingSingleScreen={widerThanLimitForPicoSwingSingleScreen}
          />
        </>
      ) : centorOnlyOption ||
        (!centorOnlyOption && screenTypeChoice && isCentor) ? (
        <>
          {addScrollElements([
            "Add Screen",
            "Screen Layout",
            "Screen Extrusion Color",
            "Shade Layout",
            "Shade Mesh Color",
            "Shade Extrusion Color",
            "Combo Layout",
            "Combo Mesh Color",
            "Combo Extrusion Color",
            "Centor Screen"
          ])}

          <CentorScreenAccordian width={width} widthRight={widthRight} />
        </>
      ) : null}
    </>
  );
};

export default BrioOrCentorAccordian;
